import { createContext, useCallback, useContext, useMemo, useState } from "react";

const AssistantContext = createContext(null);

/**
 * Global state for "Spør HydroHub": the right-side panel, the current plant context (set by plant pages)
 * and a pending question + context handed over by contextual entry points (chart, plant, event).
 * ask context: { plantId, plantName, label, question }
 */
export const AssistantProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [plantContext, setPlantContext] = useState(null); // { id, name } of the plant currently viewed
  const [pending, setPending] = useState(null); // { question, plantId, plantName, label }

  const openWith = useCallback((question, ctx = {}) => {
    setPending(question || ctx.label ? { question: question || null, ...ctx } : null);
    setOpen(true);
  }, []);

  const value = useMemo(() => ({ open, setOpen, openWith, plantContext, setPlantContext, pending, setPending }), [open, openWith, plantContext, pending]);
  return <AssistantContext.Provider value={value}>{children}</AssistantContext.Provider>;
};

export const useAssistant = () => {
  const ctx = useContext(AssistantContext);
  if (!ctx) throw new Error("useAssistant must be used within AssistantProvider");
  return ctx;
};
